import {
  SET_SETTINGS,
  BLOCKS_MINED_ADD,
  SET_LOADING
} from '../types';
import {initSocket} from '../../init';

export function updateSettings(settings,done) {
  return function(dispatch,getState) {
    dispatch({type: SET_SETTINGS,payload:settings});
    done();
  }
}

export function setLoading(load){
  return function(dispatch,getState) {
    dispatch({type:SET_LOADING,payload:load})
  }
}

export function stopConnection() {
  return function(dispatch,getState) {
    dispatch({type:BLOCKS_MINED_ADD,payload:{height:'SYNCING',timestamp:0}});
    if(getState().socket.socket && getState().socket.socket.disconnect) getState().socket.socket.disconnect();

    let settings = getState().settings.settings;
    settings.manualConnect = false;
    settings.autoConnect = false;
    settings.hostname = 'http://localhost';
    settings.port = '3000';
    settings.scookie = 'testCookie123';
    dispatch({type: SET_SETTINGS,payload:settings});
  }
}

export function updateConnection(settings,done) {
  return function(dispatch,getState) {
    console.log({settings})
    dispatch({type:BLOCKS_MINED_ADD,payload:{height:'SYNCING',timestamp:0}});
    if(getState().socket.socket && getState().socket.socket.connected) getState().socket.socket.disconnect();
    initSocket({hostname:settings.hostname,port:settings.port,scookie:settings.scookie},dispatch,{getState});

    dispatch({
      type: SET_SETTINGS,
      payload:settings
    });

    setTimeout(()=>{done()},200);
  }
}
